import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IContractNotification } from '@api'
import { LeaseNotificationsFragment } from '@api/fragments'

interface IPayload {
  data: {
    viewer: {
      company: {
        buildings: {
          id: string
          notifications: IContractNotification[]
          floors: {
            id: string
            notifications: IContractNotification[]
          }[]
        }
      }
    }
  }
}

export default function (): Promise<IPayload> {
  return client.gql.query({ query }).then((response: any) => {
    let buildings = response.data.viewer.company.buildings

    for (const building of buildings) {
      building.notifications = building.notifications.edges?.map((n: any) => n.node) || []
      for (const floor of building.floors || [])
        floor.notifications = floor.notifications.edges?.map((n: any) => n.node) || []
    }
    buildings = buildings.filter((b: any) => {
      b.floors = (b.floors || []).filter((f: any) => f.notifications.length)
      return b.notifications.length || b.floors.length
    })

    response.data.viewer.company.buildings = buildings
    return response
  })
}

export function updateNotification(id: string, status: string) {
  return client.gql.mutate({
    mutation: updateMutation,
    variables: {
      input: { notificationEventId: id, status },
    },
  })
}

const query = gql`
  query listNotifications {
    viewer {
      company {
        buildings {
          id
          notifications {
            edges {
              node {
                ...LeaseNotificationsFragment
              }
            }
          }
          floors {
            id
            notifications {
              edges {
                node {
                  ...LeaseNotificationsFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${LeaseNotificationsFragment}
`
const updateMutation = gql`
  mutation updateNotification($input: UpdateEmployeeNotificationEventInput!) {
    updateEmployeeNotificationEvent(input: $input) {
      notificationEvent {
        id
      }
    }
  }
`
